import {request} from "../request/request";

const teacher = {
  filters: () => request.read('/teacher/filters'),
  all: (params) => request.read('/teacher', params),
};

export {teacher};